import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}

import { computed, onMounted, watch, nextTick, Ref, shallowReactive } from 'vue'
    import { useRoute } from 'vue-router'

    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import ProjectsGrid from '@Quest/Projects/Components/ProjectsGrid.vue'

    import type { AllProjectsPageReadModel } from '@Quest/Strategies/readmodels'
    import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid"

    import { useAllProjectsPageQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { useSaveViewAllProjectsPageCommandV1 } from '@Quest/Strategies/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AllProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const grid = shallowReactive(new ProjectsGridViewModel())

    const {
        runAllProjectsPageQueryV1,
        modelAllProjectsPageQueryV1
    } = useAllProjectsPageQueryV1(workspaceId, strategyId)

    const rm = modelAllProjectsPageQueryV1 as Ref<AllProjectsPageReadModel | null>

    const {
        invokeSaveViewAllProjectsPageCommandV1,
        succeedSaveViewAllProjectsPageCommandV1
    } = useSaveViewAllProjectsPageCommandV1(workspaceId, strategyId)

    watch(
        rm,
        async (model) =>
        {
            if (!model) return

            await nextTick()

            grid.renderGrid(
                model.Grid.IdField,
                model.Grid.Fields,
                model.Grid.DefaultFieldIds,
                model.Grid.Options
            )

            grid.setProjects(model.Projects.map(p => p.Properties))
        },
        { immediate: true }
    )

    watch(succeedSaveViewAllProjectsPageCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            alert("Saved")
        }
    })

    function handleShowGridColumnsEditor()
    {
        grid.showGridColumnsEditor()
    }

    function handleSaveViewSettings()
    {
        const json = grid.getJson()
        invokeSaveViewAllProjectsPageCommandV1({ grid: json })
    }

    function handleClearGridFilters()
    {
        grid.clearFilters()
    }

    function handleExportGrid()
    {
        grid.exportGrid()
    }

    onMounted(() =>
    {
        document.title = "Enterprise All | TransparentChoice"
        runAllProjectsPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "row" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "All projects"),
          _createElementVNode("h6", { class: "text-muted mt-2" }, "Enterprise Portfolio")
        ], -1 /* CACHED */)),
        _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary",
            style: {"padding":"0.7em 2em"},
            onClick: handleSaveViewSettings
          }, "Save")
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      _createElementVNode("div", { class: "toolbar" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "toolbar-left" }, [
          _createCommentVNode("<button type=\"button\" class=\"btn btn-outline-secondary\">Action ({{selectedIds.length}})</button>")
        ], -1 /* CACHED */)),
        _createElementVNode("div", { class: "toolbar-right" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: handleShowGridColumnsEditor
          }, "Edit columns"),
          _createElementVNode("div", { class: "btn-group" }, [
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary dropdown-toggle",
              "data-toggle": "dropdown"
            }, " Actions ", -1 /* CACHED */)),
            _createElementVNode("div", { class: "dropdown-menu dropdown-menu-right" }, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: handleClearGridFilters
              }, "Clear Filters")
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: handleExportGrid,
            title: "Download to spreadsheet"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
          ]))])
        ])
      ]),
      _createVNode(ProjectsGrid, { viewModel: _unref(grid) }, null, 8 /* PROPS */, ["viewModel"])
    ])
  ]))
}
}

})